<template>
  <div>
    <div v-if="type === 'simple-vote'">
      <review-list-item
        :hide-change-links="hideChangeLinks || !question.isVoterEligible"
        icon="group"
        :route="route"
      >
        <span slot="label">{{ electionLabel }}</span>
        <span slot="content" v-if="question.isVoterEligible">
          {{ electionAnswer }}
        </span>
        <span slot="content" v-else>
          Voting on this question is limited to
          {{ subgroupsFormatted }}.
        </span>
      </review-list-item>
    </div>

    <div v-if="type === 'general-elections'">
      <review-list-item
        :hide-change-links="hideChangeLinks || !question.isVoterEligible"
        icon="group"
        :route="route"
      >
        <span slot="label">{{ electionLabel }}</span>
        <span slot="content" v-if="question.isVoterEligible">
          {{ electionAnswer }}
        </span>
        <span slot="content" v-else>
          Voting on this question is limited to
          {{ subgroupsFormatted }}.
        </span>
      </review-list-item>
    </div>

    <div
      v-if="
        type === 'owner-occupied' && (isResident || !question.isVoterEligible)
      "
    >
      <review-list-item
        :hide-change-links="hideChangeLinks || !question.isVoterEligible"
        icon="contacts"
        :route="route"
      >
        <span slot="label">{{ electionLabel }}</span>
        <span slot="content" v-if="question.isVoterEligible">
          {{ electionAnswer }}
        </span>
        <span slot="content" v-else>
          Voting on this question is limited to
          {{ subgroupsFormatted }}.
        </span>
      </review-list-item>
    </div>

    <div v-if="type === 'substitute-elections'">
      <review-list-item
        :hide-change-links="hideChangeLinks || !question.isVoterEligible"
        icon="transfer_within_a_station"
        :route="route"
      >
        <span slot="label">{{ electionLabel }}</span>
        <span slot="content" v-if="question.isVoterEligible">
          {{ electionAnswer }}
        </span>
        <span slot="content" v-else>
          Voting on this question is limited to
          {{ subgroupsFormatted }}.
        </span>
      </review-list-item>
    </div>

    <div
      v-if="
        type === 'substitute-elections-oo' &&
          (isResident || !question.isVoterEligible)
      "
    >
      <review-list-item
        :hide-change-links="hideChangeLinks || !question.isVoterEligible"
        icon="transfer_within_a_station"
        :route="route"
      >
        <span slot="label">{{ electionLabel }}</span>
        <span slot="content" v-if="question.isVoterEligible">
          {{ electionAnswer }}
        </span>
        <span slot="content" v-else>
          Voting on this question is limited to
          {{ subgroupsFormatted }}.
        </span>
      </review-list-item>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import ReviewListItem from './ReviewListItem.vue';

import {subgroups} from '@/vuex/helpers.js';

export default {
  components: {
    ReviewListItem
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    questionId: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    isResident: {
      type: Boolean
    },
    hideChangeLinks: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    electionLabel() {
      return this.question.name
        ? `${this.question.name}`
        : 'Your vote(s) for this election';
    },
    route() {
      return `/questions/${this.questionId}`;
    },
    electionAnswer() {
      let votes = this.question.vote.selection.filter(Boolean);

      if (_.isEmpty(votes)) {
        return this.question.vote.option[0];
      } else {
        return votes.join(', ');
      }
    },
    subgroupsFormatted() {
      return subgroups(this.question).toUpperCase();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Review/ReviewQuestionElectionItem.vue